import { inject, Injectable } from '@angular/core';
import { WebSocketService } from './web-socket.service';
import { AuthService } from './auth.service';
import { TopicType } from '../enums/topic-type';
import { LocatingSpace } from '@interfaces/location/locating-space';
import { RoomLocation } from '@interfaces/location/room-location';

@Injectable({
  providedIn: 'root',
})
export class TaskAssignmentService {
  private webSocketService = inject(WebSocketService);
  private authService = inject(AuthService);

  sendNewTask(config: any) {
    const username = this.authService.user().username;
    const location = this.normalizeLocation(config.location);

    const message: object = {
      description: config.description,
      location,
      username: username,
    };
    this.webSocketService.send({
      topic: TopicType.TASK_NOTIFICATION_REQUEST,
      message,
    });
  }

  private normalizeLocation(location: RoomLocation | LocatingSpace | string) {
    if (typeof location === 'string') {
      return location;
    }

    if (location && 'navName' in location) {
      return location.navName;
    }

    return location?.room ?? '';
  }
}
